import React from "react";
import { Typography } from "antd";
import { isEmpty } from "lodash";
import OttoDrawer from "./OttoDrawer";

const { Title, Paragraph } = Typography;

const OttoMetricsInfo = ({ open, onClose, title = "Info", width = 400, metricDetails = {} }) => {
  const {
    header,
    description,
    metrics = [],
    list = {},
    sections = [],
    bottomDescription,
  } = metricDetails;

  return (
    <OttoDrawer open={open} onClose={onClose} title={title} width={width}>
      <div>
        {header && <Title level={5}>{header}</Title>}
        {description && <Paragraph style={{ whiteSpace: "pre-wrap" }}>{description}</Paragraph>}
        {!isEmpty(metrics) && (
          <div className="space-y-4 mt-8">
            {metrics.map((m, idx) => (
              <div
                className="!rounded-xl bg-[#F5F5F5] border border-solid border-[#00000040] p-4"
                key={idx}
              >
                <div>
                  <div className="font-semibold text-black-88 text-sm mb-2">{m.label}</div>
                  <div className="text-sm text-black-88 font-normal">{m.description}</div>
                </div>
              </div>
            ))}
          </div>
        )}
        {!isEmpty(list) && list?.items && (
          <div className="mt-6">
            {list.listHeader && (
              <div className="font-semibold text-black-88 text-sm mb-3">{list.listHeader}</div>
            )}
            <ul className="list-disc pl-7 mt-5 space-y-1">
              {list.items.map((item, idx) => (
                <li
                  key={idx}
                  className="text-sm text-black-88"
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              ))}
            </ul>
          </div>
        )}
        {!isEmpty(sections) && (
          <div className="mt-6 space-y-5">
            {sections.map((section, idx) => (
              <div key={idx}>
                {section.title && (
                  <div className="font-semibold text-black-88 text-sm mb-2">{section.title}</div>
                )}
                {section.items && (
                  <ul className="list-disc pl-7 space-y-1">
                    {section.items.map((item, i) => (
                      <li
                        key={i}
                        className="text-sm text-black-88"
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        )}
        {bottomDescription && (
          <Paragraph className="mt-6" style={{ whiteSpace: "pre-wrap" }}>
            {bottomDescription}
          </Paragraph>
        )}
      </div>
    </OttoDrawer>
  );
};

export default OttoMetricsInfo;
